import { useSelector } from 'react-redux';
import AutoComplete, { usePlacesWidget } from "react-google-autocomplete";
import { GOOGLE_MAPS_API_KEY } from '../../api';

/**
 * Geocodes a formatted address string to latitude and longitude coordinates.
 * Requires the Google Maps JavaScript API script to be loaded.
 *
 * @param {string} formattedAddress The formatted address string from Places Autocomplete.
 * @returns {Promise<{ lat: number, lng: number } | null>} A Promise that resolves with the coordinates { lat, lng } or null if geocoding fails.
 */
async function geocodeAddress(formattedAddress) {
    // Check if the Google Maps API is loaded and the Geocoder service is available
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
        console.error("Google Maps Geocoding service not available. Ensure the API script is loaded.");
        return null;
    }

    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve) => {
        geocoder.geocode({ address: formattedAddress }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (results && results[0] && results[0].geometry && results[0].geometry.location) {
                    const location = results[0].geometry.location;
                    // The .lat() and .lng() methods return numbers
                    resolve({ lat: location.lat(), lng: location.lng() });
                } else {
                    // Geocode was successful but returned no results or location
                    console.warn("Geocoding successful but no results or location found.");
                    resolve(null);
                }
            } else {
                // Geocoding failed
                console.error(`Geocoding failed due to: ${status}`);
                resolve(null);
            }
        });
    });
}





const RouteWaypointSearch = ({ id, onSubmit, className, innerRef, ...props }) => {
    const { ref } = usePlacesWidget({
        apiKey: GOOGLE_MAPS_API_KEY,
        onPlaceSelected: (place) => {
            ref.current.value = "";
            ref.current.focus();

            if (!place.geometry || !place.geometry.location) return;

            // place.geometry.location is inaccurate, so we use geocodeAddress to get the correct lat/lng
            geocodeAddress(place.formatted_address).then((location) => {
                if (location) {
                    place.geometry.location.lat = () => location.lat;
                    place.geometry.location.lng = () => location.lng;
                    console.log("Got more accurate lat/lng from geocodeAddress:", location);
                    onSubmit(ref.current, place);
                }
            });
        },
        libraries: [],
        language: "et",
        region: "EE",
        options: {
          types: ["geocode", "establishment"],
        },
    });

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    };

    let displayedWaypoints = useSelector((state) => state.inquery.waypoints);

    return (
        <input
            ref={(el)=> {ref.current = el; if(innerRef) innerRef.current = el;}}
            className={`input ${className}`}
            placeholder={id == 0 ? "Sisesta reisi alguspunkt" : "Sisesta vahe- või lõpp-peatus"}
            onKeyDown={handleKeyDown}
            {...props}
        />
    );
};

export default RouteWaypointSearch;